import type { ViewProps, GameProps, CategoryProps } from '../../types';

interface AllViewProps extends ViewProps {
  // Availability depends on the page type:
  collections?: CategoryProps[],
  collection?: CategoryProps,
  game?: GameProps,
}

import * as React from 'react';
import Container from '@mui/material/Container';
import { Typography as MuiTypography } from '@mui/material';
import { BreadCrumbs } from '../BreadCrumbs';
// import { useTranslation } from 'next-i18next';
// import { useTheme } from '@mui/material/styles';

import { DefaultContent } from '../DefaultContent';
// import { useAppContext } from '../../contexts/AppContext';
import { useHighlightHandlers } from '../../contexts/HighlightContext/Highlight';

const Typography = React.forwardRef<HTMLInputElement, any>((props, ref) =>
  useHighlightHandlers(MuiTypography, { forwardedRef: ref, ...props })
);

/**
 * This component is used as fallback view in case no component for a page
 * is set during a BigBang site build.
 *
 * This component can be used as example "view" component within our NPM framework.
 *
 * @param props AllViewProps (don't use the AllViewProps type, use a specific one instead.)
 * @constructor
 */
export function DefaultView(props: AllViewProps) {
  const {
    // global,
    pageContext,
    title,
    body,

    // Availability depends on the page type:
    // collections,
    // collection,
    // game,
  } = props;
  const h1Ref = React.useRef<HTMLInputElement | null>(null);
  // const theme = useTheme();
  // const appContext = useAppContext();
  // const {
  //   componentOptions,
  // } = appContext.useConfig();
  // const {
  //   user,
  //   isLoading,
  //   isError
  // } = appContext.useUser();

  // The 'common' translations namespace is passed on server side (getStaticProps) already.
  // const { t } = useTranslation();

  // React.useEffect(() => {
  //   console.info({
  //     global,
  //     pageContext,
  //     title,
  //     body,
  //     appContext,
  //     componentOptions,
  //     collections,
  //     collection,
  //     game,
  //   });
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // React.useEffect(() => {
  //   if (!user) return;
  //   console.info({ user });
  // }, [user]);

  // if (isLoading) return <div>loading...</div>
  // if (isError) return <div>failed to load</div>

  return (
    <Container maxWidth="md">
      <BreadCrumbs breadcrumbs={pageContext.breadcrumbs}/>
      <DefaultContent body={body}>
        {title && (
          <Typography ref={h1Ref} component="h1" variant="h1">
            {title}
          </Typography>
        )}
      </DefaultContent>
    </Container>
  );
}
